import { PluginListenerHandle } from '@capacitor/core';
export interface VideoPlayerState {
    currentMillis?: number;
    totalMillis?: number;
}
export interface AudioPlayerState {
    state?: 'NONE' | 'LOADING' | 'BUFFERING' | 'RUNNING' | 'READY_TO_PLAY' | 'STOPPED';
    currentMillis?: number;
    totalMillis?: number;
    errorMessage?: string;
    timestamp?: number;
    remainingTime?: number;
}
export interface AudioNotificationOptions {
    forwardIncrementMs?: number;
    rewindIncrementMs?: number;
}
export interface DownloadState {
    medias: {
        [key: string]: DownloadStateMediaInfo;
    };
}
export declare enum DownloadStatus {
    REQUESTED = "REQUESTED",
    IN_PROGRESS = "IN_PROGRESS",
    PAUSED = "PAUSED",
    CANCELED = "CANCELED",
    COMPLETED = "COMPLETED",
    DELETED = "DELETED",
    FAILED = "FAILED"
}
export interface DownloadStateMediaInfo {
    status?: DownloadStatus;
    estimatedSize?: number;
    maxSize?: number;
    downloadedBytes?: number;
    progress?: number;
    reason?: string;
    title?: string;
    id?: string;
}
export interface BrightcovePlayerPlugin {
    addListener(eventName: string, listenerFunc: (...args: any) => void): Promise<PluginListenerHandle> & PluginListenerHandle;
    removeAllListeners(): Promise<void>;
    updateBrightcoveAccount(options: {
        accountId: string;
        policyKey: string;
    }): Promise<void>;
    playVideo(options: {
        fileId: string;
        position?: number;
        local?: boolean;
        animatedText?: string;
    }): Promise<{
        name: string;
        duration: number;
    }>;
    setSubtitleLanguage(options: {
        language: string;
    }): Promise<void>;
    loadAudio(options: {
        fileId: string;
        local?: boolean;
    }): Promise<{
        name?: string;
        duration?: number;
    }>;
    stopAudio(): Promise<void>;
    pauseAudio(): Promise<void>;
    playAudio(): Promise<void>;
    backwardAudio(options: {
        amount?: number;
    }): Promise<void>;
    forwardAudio(options: {
        amount?: number;
    }): Promise<void>;
    seekToAudio(options: {
        position: number;
    }): Promise<void>;
    enableAudioLooping(options?: {
        time: number;
    }): Promise<void>;
    disableAudioLooping(): Promise<void>;
    isAudioLooping(): Promise<{
        value: boolean;
    }>;
    getVideoPlayerState(): Promise<VideoPlayerState>;
    getAudioPlayerState(): Promise<AudioPlayerState>;
    destroyAudioPlayer(): Promise<void>;
    setAudioNotificationOptions(options: AudioNotificationOptions): Promise<void>;
    isMediaAvailableLocally(options: {
        fileId: string;
    }): Promise<{
        value: boolean;
    }>;
    downloadMedia(options: {
        fileId: string;
    }): Promise<void>;
    getDownloadedMediasState(): Promise<{
        medias: Array<DownloadStateMediaInfo>;
    }>;
    deleteDownloadedMedia(options: {
        fileId: string;
    }): Promise<void>;
    notifyBackButtonPressed(): Promise<void>;
    playInternalAudio(options: {
        file: string;
    }): Promise<void>;
    deleteAllDownloadedMedias(): Promise<void>;
}
